import { render, staticRenderFns } from "./BaseTrumpetSelect.vue?vue&type=template&id=aa4bcb18&scoped=true"
import script from "./BaseTrumpetSelect.vue?vue&type=script&lang=js"
export * from "./BaseTrumpetSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseTrumpetSelect.vue?vue&type=style&index=0&id=aa4bcb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4bcb18",
  null
  
)

export default component.exports